<script setup lang="ts">
  import RasterDataIndex from './RasterDataIndex.vue'
  import UploadToBlobStorageDialog from '@/components/uploadToBlobStorage/UploadToBlobStorageDialog.vue'
  import HeaderWithActions from '@/components/projectDetail/components/HeaderWithActions.vue'
  import PrimaryButton from '@/components/shared/PrimaryButton.vue'

  const store = useProjectStore()
  const rasterDataDrawer = ref<HTMLElement | null>(null)
  const rasterFileUploadStore = useRasterFileUploadStore()
  const authorizationStore = useAuthorizationStore()

  const canAdd = computed(() => {
    return authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: 'add_rasterfileupload'
    })
  })

  useResizeableElement({
    ref: rasterDataDrawer,
    widthProperty: 'rasterDataDrawer',
    elementGetter: vDrawerElementGetter
  })
</script>

<template>
  <v-navigation-drawer
    :temporary="true"
    :scrim="false"
    ref="rasterDataDrawer"
    :model-value="store.rasterDataDrawer.shown"
    :width="store.rasterDataDrawer.width"
    :class="['raster-drawer', 'resize-handler-elevation']"
  >
    <HeaderWithActions>
      <template #default> Raster Data Management</template>
      <template #actions>
        <v-tooltip text="Upload profiles" v-if="canAdd">
          <template v-slot:activator="{ props }">
            <PrimaryButton
              prepend-icon="mdi-plus"
              v-bind="props"
              @click="rasterFileUploadStore.toggleAddRasterFileDialog()"
            >
              Add
            </PrimaryButton>
          </template>
        </v-tooltip>
      </template>
      <template #subheader> Upload and manage raster data </template>
    </HeaderWithActions>
    <v-divider />
    <RasterDataIndex />
  </v-navigation-drawer>
  <UploadToBlobStorageDialog />
</template>

<style scoped>
  .resize-handler-elevation {
    border-right-width: 10px;
    z-index: 1;
    box-shadow: none;
  }

  .hidden {
    display: none;
    opacity: 0;
    transition: opacity 0.5s ease;
  }

  :deep(.v-navigation-drawer__content) {
    overflow-y: hidden;
  }

  .raster-drawer {
    transition: border-bottom-color 0.3s;
    border-right: 10px solid rgba(0, 0, 0, 0.1);
  }
</style>
